import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import classnames from 'classnames/bind';
import { getCssColorFromColorName } from '../../../utils/colors';
import { ColorNames } from '../../../constants/colorVars';
import Icon from '../icon';
import HorizontalExpander from '../horizontalExpander';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const TRANSITION_MS = 200;
const InfoPill = ({ iconName, iconColor, icon, iconOnRight = false, content, elmId = 'info-pill', size = 'small', backgroundColor = ColorNames.OffWhiteDark, foregroundColor = ColorNames.Gray, includeBorder = false, className, style, extraPadding, fontWeight = 'bold', label, iconStyle = 'solid', interactive = 'none', disabled = false, }) => {
    const backgroundColorRaw = getCssColorFromColorName(backgroundColor);
    const foregroundColorRaw = getCssColorFromColorName(foregroundColor);
    const colorStyles = useMemo(() => ({
        background: backgroundColorRaw,
        color: foregroundColorRaw,
        border: `1px solid ${includeBorder ? foregroundColorRaw : backgroundColorRaw}`,
    }), [backgroundColorRaw, foregroundColorRaw, includeBorder]);
    const _icon = useMemo(() => iconName ? (_jsx(Icon, { name: iconName, color: iconColor || 'inherit', iconStyle: iconStyle, fitted: true })) : React.isValidElement(icon) ? (React.cloneElement(icon, {
        className: cx(backgroundColor, icon?.props?.className),
    })) : (icon), [iconName, iconColor, iconStyle, icon, backgroundColor]);
    const renderPill = useCallback(() => (_jsx("div", { className: cx('info-pill', size, backgroundColor, `interactive-${interactive}`, { disabled }, { 'icon-on-right': iconOnRight }, { 'include-border': includeBorder }, { 'extra-padding-small': extraPadding === 'small' }, { 'extra-padding-medium': extraPadding === 'medium' }, { 'font-weight-normal': fontWeight === 'normal' }, className), style: { ...colorStyles, ...style }, "data-elm-id": elmId || 'info_pill', children: _jsx(HorizontalExpander, { transitionDurationMs: TRANSITION_MS, children: _jsxs("div", { className: cx('content'), children: [!iconOnRight && _icon, content && _jsx("div", { className: cx('text'), children: content }), iconOnRight && _icon] }) }) })), [
        size,
        backgroundColor,
        interactive,
        disabled,
        iconOnRight,
        includeBorder,
        extraPadding,
        fontWeight,
        className,
        colorStyles,
        style,
        elmId,
        _icon,
        content,
    ]);
    return (_jsx(_Fragment, { children: label ? (_jsxs("div", { "data-elm-id": `${elmId}-container`, className: cx('container'), children: [renderPill(), _jsx("div", { className: cx('label'), children: label })] })) : (renderPill()) }));
};
const Group = ({ className, children, style }) => (_jsx("div", { className: cx('info-pill-group', className), style: style, children: children }));
const InfoPillWithStatic = InfoPill;
InfoPillWithStatic.Group = Group;
export default InfoPillWithStatic;
//# sourceMappingURL=index.js.map